@if (transcript) {
  <div class="transcript-wrapper" [class.mobile-transcript]="isMobile">
    <div class="transcript-header" [class.column-style]="!isMobile">
      @if (!isMobile) {
        <mb-transcript-section-selection
          [options]="sections"
          [activeSection]="activeSection || ''"
          (sectionChanged)="sectionChanged($event)"
        >
        </mb-transcript-section-selection>
        @if (transcript.tags.length > 1) {
          <div class="header-separator"></div>
          <mb-transcript-tag-selection
            [activeFilter]="transcript.filters"
            [tags]="transcript.tags"
            (selectionChange)="filtersChanged($event)"
          ></mb-transcript-tag-selection>
        }
      } @else {
        @if (transcript.tags.length > 1) {
          <mb-select
            [hideLabel]="true"
            [useNativeSelect]="false"
            [icon]="'mb-icon-filter-flat'"
            [options]="transcript.tagOptions"
            (selectionChanged)="filtersSelectChanged($event)"
          ></mb-select>
        }
        <div class="close-btn btn btn-plain" (click)="closeTranscript.emit()">
          <span class="mb-icon mb-icon-close"></span>
        </div>
      }
    </div>
    <mb-transcript-content
      [isMobile]="isMobile"
      [synced]="synced"
      [entries$]="transcript.entries"
      [speakers]="transcript.transcriptSpeakers"
      [player]="player"
      [disableActionAssets]="transcript.disableActionAssets"
      [disabledActionAssetsToastText]="transcript.disabledActionAssetsToastText"
      [currentEntry]="currentEntry"
      [activeEntry]="activeEntry"
      [displaySpeaker]="!transcript.filters.length"
      (scrolled)="contentScrolled()"
      (openMedia)="openMedia.emit($event)"
    ></mb-transcript-content>
    <div class="transcript-footer" [class.is-mobile]="isMobile">
      <div class="transcript-footer-left">
        @if (!synced) {
          <button class="btn btn-plain" (click)="sync()">
            <span class="mb-icon mb-icon-resync"></span>
            <span>{{ 'RESYNC' | translate }}</span>
          </button>
        }
      </div>
      <div class="transcript-footer-right">
        @if (transcript.languageOptions.length > 1) {
          <mb-dropdown
            icon="mb-icon-language-country-switch"
            [value]="transcript.lang"
            (selectionChanged)="langChanged.emit($event ? $event.value : null)"
            [options]="transcript.languageOptions"
            [openTop]="true"
          ></mb-dropdown>
        }
        @if (transcript.canBookmark) {
          <mb-action-container [buttonItems]="transcriptActions" [resource]="transcript"></mb-action-container>
        }
      </div>
    </div>
  </div>
}
